import axios from "axios"
import useSWR from "swr"

const fetcher = async (url, params) => {
  return await axios.get(url, { params }).then((res) => res.data.data)
}

const useStockOpnameListRepositories = (params) => {
  const shouldFetch = params?.enabled !== false
  const requestParams = { ...params }
  delete requestParams.enabled

  const { data, error, mutate, isValidating } = useSWR(
    shouldFetch
      ? [`${process.env.REACT_APP_INVENTORY_API_URL}/stock-opname`, requestParams]
      : null,
    fetcher
  )

  return {
    data,
    isLoading: shouldFetch && !error && !data,
    error,
    isValidating,
    mutate,
  }
}

export default useStockOpnameListRepositories

export const useStockOpnameDetailRepositories = (id, enabled = true) => {
  const shouldFetch = !!id && enabled

  const { data, error, mutate, isValidating } = useSWR(
    shouldFetch
      ? [`${process.env.REACT_APP_INVENTORY_API_URL}/stock-opname/${id}`, null]
      : null,
    fetcher
  )

  return {
    data,
    isLoading: shouldFetch && !error && !data,
    error,
    isValidating,
    mutate,
  }
}

export const useStockOpnameVarianceRepositories = (id, params, enabled = true) => {
  const shouldFetch = !!id && enabled
  const requestParams = { ...(params || {}) }

  const { data, error, mutate, isValidating } = useSWR(
    shouldFetch
      ? [`${process.env.REACT_APP_INVENTORY_API_URL}/stock-opname/${id}/variance`, requestParams]
      : null,
    fetcher,
    { keepPreviousData: true }
  )

  return {
    data,
    isLoading: shouldFetch && !error && !data,
    error,
    isValidating,
    mutate,
  }
}

export const useStockOpnameActiveByOutletRepositories = (outletId, enabled = true) => {
  const shouldFetch = !!outletId && enabled

  const { data, error, mutate, isValidating } = useSWR(
    shouldFetch
      ? [`${process.env.REACT_APP_INVENTORY_API_URL}/stock-opname/active`, { outlet_id: outletId }]
      : null,
    fetcher
  )

  return {
    data,
    isLoading: shouldFetch && !error && !data,
    error,
    isValidating,
    mutate,
  }
}

export const useStockCheckDetailRepositories = (freezeId, checkId, enabled = true) => {
  const shouldFetch = !!freezeId && !!checkId && enabled

  const { data, error, mutate, isValidating } = useSWR(
    shouldFetch
      ? [`${process.env.REACT_APP_INVENTORY_API_URL}/stock-opname/${freezeId}/checks/${checkId}`, null]
      : null,
    fetcher
  )

  return {
    data,
    isLoading: shouldFetch && !error && !data,
    error,
    isValidating,
    mutate,
  }
}
